import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { statusClasses, statusLabel } from "@/lib/status-maps";

/**
 * Canonical status pill. Single source of truth for status colors across the app.
 *
 * <StatusBadge status="OUT_FOR_DELIVERY" kind="trip" />
 *
 * props:
 *  - status: raw status string (any case / spacing)
 *  - kind: 'order'|'trip'|'shipment'|'session'|'grn'|'pickup'|'escalation'|'job'|'generic'
 *  - size: 'sm'|'md'|'lg'
 *  - label: override display text (defaults to a humanized status)
 */
const SIZES = {
  sm: "text-[10px] px-2 py-0",
  md: "text-xs px-2.5 py-0.5",
  lg: "text-sm px-3 py-1",
};

export function StatusBadge({ status, kind = "order", size = "md", label, className }) {
  if (status === null || status === undefined || status === "") return null;
  return (
    <Badge
      variant="outline"
      className={cn("border-0 font-semibold whitespace-nowrap", statusClasses(status, kind), SIZES[size], className)}
    >
      {label ?? statusLabel(status)}
    </Badge>
  );
}

export default StatusBadge;
